// Brand marks for the integration registry, keyed by the unions it derives, so a
// provider added there without a mark is a compile error. Kept apart from the
// registry because these reach into .tsx modules.

import { TbBrandGithub } from "solid-icons/tb";
import type { Component } from "solid-js";
import { GoogleWorkspaceLogo, LinearLogo, NotionLogo, SlackLogo } from "~/components/integrations/IntegrationSection";
import { GoogleDriveIcon, NotionIcon } from "~/components/knowledge/pages/ScopePickerEmptyState";
import type { AssetSource, IntegrationProviderId } from "./integrationProviders";

type Glyph = Component<{ class?: string }>;

export const INTEGRATION_PROVIDER_ICONS: Record<IntegrationProviderId, Glyph> = {
  google: GoogleWorkspaceLogo,
  slack: SlackLogo,
  notion: NotionLogo,
  linear: LinearLogo,
  github: TbBrandGithub,
};

export const ASSET_SOURCE_ICONS: Record<AssetSource, Glyph> = {
  gdrive: GoogleDriveIcon,
  notion: NotionIcon,
  linear: LinearLogo,
  github: TbBrandGithub,
};
